// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeeMoreButton[data-v-bc3588ea]{padding:15px 0}.le-blurb[data-v-bc3588ea]{padding:0 15px 15px;}.le-blurb[data-v-bc3588ea]  p:first-child{margin-top:0}.le-blurb[data-v-bc3588ea]  p{margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
